module.exports = __webpack_public_path__ + "video/1700-2_YR_2022_Malware.eaf7e268.vtt";